<template>
  <div
    class="sidebar-form-group opacity-group"
    dta-test="graphics-opacitySettings"
  >
    <label
      class="sidebar-form-label"
      for="opacity"
    >Opacity</label>
    <div class="flex items-center opacity-group__controls">
      <div class="range-slider">
        <input
          v-model.number="opacity"
          class="range-slider__input no-tooltip"
          type="range"
          name="opacitySlider"
          min="0"
          max="100"
          aria-label="Alternative slider input for Opacity"
          data-test="graphics-opacitySettings-slider"
          data-entity="graphics-opacitySettings-slider"
        />
      </div>
      <div class="opacity-group__number-input">
        <div class="input-group">
          <input
            v-model.number.lazy="opacity"
            type="number"
            name="opacity"
            min="0"
            max="100"
            step="1"
            data-test="graphics-opacitySettings-opacityInput"
            data-entity="graphics-opacitySettings-opacityInput"
          />
          <span class="input-group-addon symbol">%</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    opacity: {
      get() {
        return Math.round(this.modelValue * 100);
      },
      set(v) {
        let value = v;
        if (v > 100) value = 100;
        if (v < 0) value = 0;
        this.$emit('update:modelValue', (value / 100));
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.opacity-group__controls {
  gap: 8px
}
.opacity-group__number-input {
  min-width: 75px;
}
.range-slider {
  top: -4px;
}
</style>
